import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import { LinkProps } from 'react-router-dom'

const StyledIconButton = styled(IconButton)<LinkProps>(({ theme }) => ({
  marginRight: theme.spacing(2),
  color: 'inherit',
}))

const StyledRoot = styled('div')(() => ({
  marginBottom: 40,
}))

export { StyledIconButton, StyledRoot }
